export enum IntegrationPartner {
    dbu = "DBU",
    stack = "stackSports",
    refassist = "refAssist",
    assignr = "assignr",
    knvb = "KNVB",
    refinsight = "refInsight",
    soccerRefManager = "soccerRefManager",
    /**
     * Scraped platforms (REFSIX-568). Unlike the others these have no public
     * API, no OAuth flow, no entitlement and no per-user grant — REFSIX reads
     * the referee's own browser session.
     *
     * These two values MUST equal the `id` in
     * `core/src/integrations/assignmentPlatforms.json`: that id is the `source`
     * recorded on every imported match, the key in refauth's platform mapping,
     * and what the `/integrations/assignments/matches` payload carries. Changing
     * either would orphan every already-imported fixture.
     */
    arbiter = "arbiter",
    moas = "moas",
    /**
     * YOU MUST ALSO UPDATE DISPLAY NAMES IN:
     * core/src/integrations/IntegrationPartnerDisplayName.ts
     */
}
